import React, { useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Button,
	TextField,
} from "@material-ui/core";
import { connect } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { DownloadOutlined, WindowsFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import HttpService from "../../services/httpService";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
	table: {
		minWidth: 850,
	},
	textField: {
		width: 100,
	},
	paper: {
		padding: theme.spacing(2),
		margin: "auto",
		maxWidth: 400,
	},
}));

const StyledTableCell = withStyles((theme) => ({
	head: {
		// backgroundColor: "#2C2E3E",
		backgroundColor: "#3F51B5",
		color: "#FFF",
		fontWeight: "500",
		// border: '1px solid black'
	},
	body: {
		fontSize: 14,
		// border: '1px solid red'
	},
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
	root: {
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);

const DownloadGRN = (props) => {
	const classes = useStyles();
	const { approvedProjects } = useSelector((state) => state.finance);
	const [selectedProject, setSelectedProject] = useState({});
	const [projectStatus, setProjectStatus] = useState(false);
	const [allProcurements, setAllProcurements] = useState([]);
	const [selectedOrderId, setSelectedOrderId] = useState("");
	const [showGrnModal, setShowGrnModal] = useState(false);
	const [grnModalArray, setGrnModalArray] = useState([]);

	// Function to handle the project selection
	const handleSelect = async (event, value) => {
		props.setLoading(true);
		setProjectStatus(true);
		try {
			if (value) {
				setSelectedProject(value);
				getAllProcurementsOfProject(value._id);
			} else {
				setSelectedProject({});
			}
		} catch (error) {
			console.error(error);
			props.setSnackInfo("Couldn't fetch the data", "error");
		}
		props.setLoading(false);
	};

	// Function to get all procurements of a project using project code
	const getAllProcurementsOfProject = async (projectId) => {
		try {
			const procurements =
				await HttpService.getAllProcurementsUsingProjectId(projectId);
			setAllProcurements(procurements.data);
		} catch (error) {
			console.error("Error -> ", error);
			setAllProcurements([]);
		}
	};

	// Function to get all open procurements
	const fetchOpenPoHandler = async () => {
		props.setLoading(true);
		try {
			const procurements = await HttpService.getAllInwardedOpenProcurements();
			setAllProcurements(procurements.data);
			setSelectedProject({});
		} catch (error) {
			console.error("Error -> ", error);
			setAllProcurements([]);
		}
		props.setLoading(false);
	};

	// Function to open grn modal
	const openGrnModalHandler = async (data) => {
		setSelectedOrderId(data.orderId);
		props.setLoading(true);
		try {
			const result = await HttpService.getGrnForProcurementId(data._id);
			setGrnModalArray(result.data);
			setShowGrnModal(true);
		} catch (error) {
			console.error("Error -> ", error);
			props.setSnackInfo(
				error?.response?.data ?? "Something went wrong",
				"error"
			);
		}
		props.setLoading(false);
	};

	return (
		<div>
			<div
				style={{
					marginBottom: 20,
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Paper className={classes.paper}>
					<center>
						<h2>Download GRN</h2>
					</center>
				</Paper>
			</div>

			{/* Select Projects */}
			<div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
				<Autocomplete
					value={selectedProject}
					onChange={handleSelect}
					id="project-code-dropdown"
					options={approvedProjects}
					getOptionLabel={(option) => option.searchName}
					style={{ width: 500 }}
					renderInput={(params) => (
						<TextField
							{...params}
							label="Search Project"
							fullWidth
							variant="outlined"
						/>
					)}
				/>

				<Button
					onClick={fetchOpenPoHandler}
					color="secondary"
					variant="outlined"
				>
					Open Po
				</Button>
			</div>

			{/* Data Displaying in Table */}
			{allProcurements.length > 0 ? (
				<TableContainer
					TableContainer
					component={Paper}
				>
					<Table
						className={classes.table}
						size="small"
						aria-label="customized table"
						stickyHeader
					>
						<TableHead>
							<StyledTableRow>
								<StyledTableCell>Sl No</StyledTableCell>
								<StyledTableCell>Order Id</StyledTableCell>
								<StyledTableCell>Status</StyledTableCell>
								<StyledTableCell>Vendor Name</StyledTableCell>
								<StyledTableCell>GRN Count</StyledTableCell>
								<StyledTableCell>Created At</StyledTableCell>
								<StyledTableCell>Action</StyledTableCell>
							</StyledTableRow>
						</TableHead>
						<TableBody>
							{allProcurements?.map((el, i) => {
								return (
									<StyledTableRow key={i + 1}>
										<StyledTableCell>
											{i + 1}
										</StyledTableCell>
										<StyledTableCell>
											{el?.orderId}
										</StyledTableCell>
										<StyledTableCell>
											{el?.status}
										</StyledTableCell>
										<StyledTableCell>
											{el?.vendorId?.name}
										</StyledTableCell>
										<StyledTableCell>
											{el?.grnCount}
										</StyledTableCell>
										<StyledTableCell>
											{moment(el?.createdAt).format(
												"DD-MM-YYYY"
											)}
										</StyledTableCell>
										<StyledTableCell>
											<>
												<Button
													variant="contained"
													color="primary"
													onClick={() =>
														openGrnModalHandler(el)
													}
												>
													View
												</Button>
											</>
										</StyledTableCell>
									</StyledTableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
				<p style={{ color: "red" }}>
					<b>No Data To Show</b>
				</p>
			)}

			{/* Modal for Grn Download */}
			<Modal
				title={`GRN for ${selectedOrderId}`}
				centered
				open={showGrnModal}
				onCancel={() => setShowGrnModal(false)}
				width={1000}
				maskClosable={false}
				footer={null}
			>
				{grnModalArray.length == 0 ? (
					<p style={{ color: "red" }}>
						<b>No Data to Show</b>
					</p>
				) : (
					<TableContainer component={Paper}>
						<Table
							className={classes.table}
							size="small"
							aria-label="customized table"
						>
							<TableHead>
								<TableRow>
									<StyledTableCell>Sl No</StyledTableCell>
									<StyledTableCell>
										GRN Number
									</StyledTableCell>
									<StyledTableCell>
										Date of Inwarding
									</StyledTableCell>
									<StyledTableCell>Action</StyledTableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{grnModalArray?.map((data, i) => (
									<StyledTableRow key={i + 1}>
										<StyledTableCell>
											{i + 1}
										</StyledTableCell>
										<StyledTableCell>
											{data?.grnNumber || "N/A"}
										</StyledTableCell>
										<StyledTableCell>
											{new Date(
												data?.dateOfInwarded
											)?.toLocaleDateString("en-IN")}
										</StyledTableCell>
										<StyledTableCell>
											{data?.grnLink ? (
												<DownloadOutlined
													onClick={() =>
														window.open(
															data?.grnLink
														)
													}
												/>
											) : (
												"N/A"
											)}
										</StyledTableCell>
									</StyledTableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				)}
			</Modal>
		</div>
	);
};

export default connect(null, { setLoading, setSnackInfo })(DownloadGRN);